export enum ScreenName {
  extraSmall = 'xs',
  smallDevices = 'sm',
  mediumDevices = 'md',
  largeDevices = 'lg',
  extraLarge = 'xl'
}
